module.exports = __webpack_public_path__ + "img/1557614069556518916.ef0bd6f1.png";